<template>
  <div class="parent-box">
    <!-- 列表数据 -->
    <div class="content">
      <van-list
        v-model="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell
          v-for="(item, i) in state.list"
          :key="i + '-list'"
          :border="false"
        >
          <template #value>
            <p>
              <span>积分兑换余额</span> <span>+{{ item.givemoney }}余额</span>
            </p>
            <p>花费积分：{{ item.pay_coin }}</p>
            <p>兑换时间：{{ item.pay_time }}</p>
          </template>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import { reactive, nextTick, onBeforeMount, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Toast } from "vant";
import { useStore } from "vuex";

import { setToken, getToken, removeToken } from "@/utils/auth";
import { getQueryString } from "@/utils/location";
import { exchangeRecord } from "@/api/yzuser";

export default {
  name: "dhBalance",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const state = reactive({
      list: [],
      loading: false,
      finished: false,
    });
    onMounted(() => {
      onLoad();
    });

    var pagecode = 1;
    var totalpage = 1;
    const onLoad = () => {
      // console.log(47444)
      exchangeRecord({
        // uid:33,
        uid: getQueryString("uid"),
        // uid: store.state.id,
        coin: 100,
        money: 10,
        appid: 1,
        pagecode: pagecode,
      }).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          totalpage = res.data.data.total_page;
          if (pagecode > res.data.data.total_page) {
            state.finished = true;
            return;
          }

          state.list = state.list.concat(res.data.data.lists);
          // 将数据中的时间字符串转换为时间数据
          state.list.forEach((item) => {
            const year = item.pay_time.slice(0, 4);
            const month = item.pay_time.slice(5, 7);
            const day = item.pay_time.slice(8, 10);
            item.pay_time = year + "年" + month + "月" + day + "日";
          });
        }
        console.log(pagecode);
        pagecode++;
        state.loading = false;
        console.log(state.list);
      });
    };

    return {
      state,
      // goback
      onLoad,
    };
  },
};
</script>

<style scoped="scoped">
.parent-box {
  padding-top: 60px;
  padding-bottom: 80px;
  min-height: 100vh;
  background-color: #f7f8fa;
}

.content {
  padding: 0 32px;
}

.van-cell {
  width: 686px;
  height: 220px;
  background-color: #fff;
  border-radius: 16px;
  padding: 24px 32px 24px 24px;
  font-size: 24px;
  margin-bottom: 20px;
}

.van-cell p:nth-of-type(1) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 32px;
  color: #333;
  font-weight: 500;
}
.van-cell p {
  color: #333;
}
.van-cell p:nth-of-type(2) {
  margin: 12px 0;
}
</style>
